import { Props, VersionMigrator } from './migrators'

export enum Versions {
  V1 = 1, // data has no field 'version'
  V2 = 2,
}

export const ActualVersionNumber = Versions.V2
export type ActualVersion = ObjectPropsV2

export type FabricV5Data = {
  left?: number
  top?: number
  angle?: number
  flipX?: boolean
  flipY?: boolean
}

export interface ObjectPropsV1 extends Props {
  id?: string
  blocked?: boolean
  hidden?: boolean

  data?: FabricV5Data
}

export interface ObjectPropsV2 extends Props {
  id?: string
  title?: string
  left?: number
  top?: number
  angle?: number
  flipX?: boolean
  flipY?: boolean
  blocked?: boolean
  hidden?: boolean
  createdAt?: number
  preview?: string
  bodyColour?: Rgba

  states?: string[]
}

export const migrate: VersionMigrator<ActualVersion> = (data: object) => {
  // Не проверяем номер версии, так как пока есть только две - в одной есть поле version, в другой - нет.
  // Как появится еще одна - надо будет демать как везде указать соответствие, чтобы при 4 версии
  // изображения мы знали, что это 2 или 3 версия объекта. Еще одно поле надо будет, скорее всего
  if ('version' in data) {
    return data as ObjectPropsV2
  }

  const dataV1 = data as ObjectPropsV1

  return {
    id: dataV1.id,
    type: dataV1.type,
    version: Versions.V2,
    title: '',
    left: dataV1.data?.left,
    top: dataV1.data?.top,
    angle: dataV1.data?.angle,
    flipX: dataV1.data?.flipX,
    flipY: dataV1.data?.flipY,
    blocked: dataV1.blocked,
    hidden: dataV1.hidden,
    createdAt: Date.now(),
  }
}
